import Vue, { DirectiveBinding, DirectiveOptions, VueConstructor } from 'vue';

const definition: DirectiveOptions = {
    bind: function (el: HTMLElement, binding: DirectiveBinding) {
        // We wait 250ms to no block rendering and to debounce calls
        setTimeout(() => {
            // Current element
            let elementNode = el.innerHTML;
            const flags = 'gim';

            // highlightData is added to the directive in ParticipantList
            const termsToHighlightByUser: Array<string> | undefined = binding.value.highlightData;

            if (termsToHighlightByUser === undefined) return;

            termsToHighlightByUser.map(term => {
                const regEx = new RegExp('^' + term, flags);
                // ToDo: This can cause problems early and should be adjusted if necessary
                elementNode = elementNode.trimStart().replace(regEx, `<mark class="search-highlight">${term}</mark>`);
            });

            el.innerHTML = elementNode;
        }, 250);
    },
};

const SearchHighlight = {
    install (Vue: VueConstructor<Vue>) {
        Vue.directive('search-highlight', definition);
    },
};

export default SearchHighlight;
